/**
 * @generated SignedSource<<04f6224e0808a500806cc4e8882ee699>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RepositoryLabelIndexPageContentInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelsInternal">;
  readonly " $fragmentType": "RepositoryLabelIndexPageContentInternal";
};
export type RepositoryLabelIndexPageContentInternal$key = {
  readonly " $data"?: RepositoryLabelIndexPageContentInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"RepositoryLabelIndexPageContentInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderDirection"
    },
    {
      "defaultValue": "NAME",
      "kind": "LocalArgument",
      "name": "orderField"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RepositoryLabelIndexPageContentInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "orderDirection",
          "variableName": "orderDirection"
        },
        {
          "kind": "Variable",
          "name": "orderField",
          "variableName": "orderField"
        }
      ],
      "kind": "FragmentSpread",
      "name": "RepositoryLabelsInternal"
    }
  ],
  "type": "Repository",
  "abstractKey": null
};

(node as any).hash = "eaf57022c3aa587e1bfdb5b39ef1869d";

export default node;
